// `global.css:37` sets `--ring: none`, so the `focus-visible:ring-ring` baked into `Button.tsx:16`
// resolves to nothing while its `focus-visible:outline-none` still applies: a focusable has no
// visible focus indicator unless it names a ring colour itself. New focusables apply this, or use
// `Button variant="secondary"` (`Button.tsx:24`), the one variant that already names a colour.
export const FOCUS_RING = 'focus-visible:ring-2 focus-visible:ring-green-400';
